import React from "react";
import { verificationActions } from "actions/verification.actions";
import { connect } from "react-redux";
import { FilledButton } from "@sainsburys-tech/luna-button";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import PageFormat from "components/PageFormat";
import { FAILURE_MESSAGE } from "constants/messages";

class EmailChangeConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      hasExpired: undefined,
      token: this.props.match.params.token,
    };
  }

  handleConfirmationClick = () => {
    const { dispatch } = this.props;
    this.setState({
      buttonDisabled: true,
    });
    dispatch(verificationActions.confirmEmailChange(this.state.token));
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.expired !== undefined) {
      if (nextProps.expired === true) {
        this.setState({
          hasExpired: nextProps.expired,
          success: false,
          buttonDisabled: true,
        });
      }
    }

    if (nextProps.success !== undefined) {
      if (nextProps.success === true) {
        this.setState({
          success: nextProps.success,
          hasExpired: false,
          buttonDisabled: true,
        });
      }
    }
  }

  render() {
    return (
      <PageFormat>
        <div className="c-hero c-hero--center">
          <h3>You need to confirm your email change</h3>
        </div>
        <div className="ln-u-soft ln-u-text-align-center">
          <Notification>
            Your need to provide your confirmation to successfully change your
            email.
            <br />
            To do this, please click on the link below.
          </Notification>
          <br />
          <FilledButton
            id="submit"
            type="submit"
            disabled={this.state.buttonDisabled}
            onClick={this.handleConfirmationClick}
            fullWidth
          >
            Confirm email change
          </FilledButton>
          {this.state.success || this.state.hasExpired ? (
            <div>
              <div className="ln-c-card ln-c-card--soft">
                {this.state.success ? (
                  <Notification type={NotificationStatuses.SUCCESS_TYPE}>
                    Your email change has been processed successfully.
                    <br />
                    You will need to log back in to the Smartshop app using your
                    new email address and existing password.
                  </Notification>
                ) : this.state.hasExpired ? (
                  <Notification type={NotificationStatuses.ERROR_TYPE}>
                    {FAILURE_MESSAGE}
                    <br />
                    The confirmation link is either invalid or has expired.
                    <br />
                    Please try again or contact the help desk.
                  </Notification>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </PageFormat>
    );
  }
}

function mapStateToProps(state) {
  const { success, expired } = state.verification;
  return {
    success,
    expired,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verification: (token) =>
      dispatch(verificationActions.confirmEmailChange(token)),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailChangeConfirmation);
